import React, { FC, useRef, useState } from 'react';

import { Box, HStack, Divider, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { StackedHeader } from 'components/DataDisplay';
import { DetailsField } from 'components/DataDisplay/Utils/DetailsField';
import { IconTypes } from 'components/Icons';
import { Drawer } from 'components/Overlay';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { useEnvironmentOptions } from 'containers/App/hooks/useEnvironmentOptions';
import { ResourceExceptionsTable } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Exceptions/ResourceExceptionsTable';

interface Props {
  exception: Record<string, any>;
  row: Record<string, any>;
  isOpen: boolean;
  onClose: () => void;
}

export const ResourceExceptions: FC<Props> = props => {
  const { row, isOpen, onClose, exception } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const ref = useRef(document.querySelector('.portal-container'));
  const { environmentMapping } = useEnvironmentOptions();

  return (
    <>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        header={
          <StackedHeader
            upper={exception?.alert_description}
            lower={environmentMapping?.[row?.environment_id]?.name ?? ''}
            type={IconTypes.Exception}
          />
        }
        styles={{
          content: { maxW: '1540px' },
          //drawer: { portalProps: { containerRef: ref as any } },
        }}
        closeButton
        body={
          <>
            <Stack w="full" h="full" pt={3} spacing={5}>
              <HStack spacing={10} align="start">
                <Box w="60%">
                  <DetailsField
                    label="Description"
                    isInline={false}
                    width="full"
                    spacing={2}
                    value={
                      <Box
                        border="1px solid"
                        borderColor={customTheme.colors.gray['100']}
                        h={24}
                        w="full"
                        borderRadius={6}
                        py={2}
                        px={3}
                        overflow="auto"
                      >
                        {exception.alert_description}
                      </Box>
                    }
                  />
                </Box>
              </HStack>
              <Divider color="gray.200" />
              {/*<HStack justify="space-between">
              <Box w="30%">
                <SearchBox onChange={setSearchTerm} value={searchTerm} />
              </Box>
              <HStack>
                <Box fontWeight={600} color="primary">
                  FILTERS:
                </Box>
              </HStack>
            </HStack>*/}
              <ActiveResourceProvider>
                <ResourceExceptionsTable exception={exception} row={row} />
              </ActiveResourceProvider>
            </Stack>
          </>
        }
      />
    </>
  );
};
